/**
 * This route without a path groups together a few payment-related routes
 * for the purposes of being able to hook into lifecycle method for the entire group
 * (e.g. entering & leaving the payment page group, ignoring transitions between payment pages)
 */
import urls from '../../../urls';
import {PointStages, CheckoutStages} from '../../../constants/AppConstants';
import OrderStore from '../../../stores/OrderStore';
import SmartcardStore from '../../../stores/SmartcardStore';
import PaymentStore from '../../../stores/PaymentStore';

export default {
    getComponent(location, cb) {
        require.ensure(
            [],
            require => {
                cb(null, require('../../../components/payment/Wrapper').default);
            },
            'payment-wrapper',
        );
    },

    getChildRoutes(location, cb) {
        require.ensure(
            [],
            require => {
                cb(
                    null,
                    [
                        require('./Payment').default,
                        require('./PaymentCardHosted').default,
                        require('./PaymentCardHostedBraintree').default,
                    ].filter(x => !!x),
                );
            },
            'payment-routes',
        );
    },

    async onLeave() {},

    async onEnter({routes}, replace) {
        const currentOrder = OrderStore.getCurrent();
        const smartcard = SmartcardStore.getCurrent();
        const isAwaitingProduct =
            currentOrder.isSmartcard() && smartcard ? smartcard.isAwaitingProduct() : false;
        const thisRoute = routes[routes.length - 1];
        const paymentForm = PaymentStore.getForm();

        // No order to checkout
        if (!currentOrder || currentOrder.isEmpty()) {
            replace(urls.location(PointStages.SEARCH));
        }

        // Needs fulfilment details
        else if (!currentOrder.hasFulfilment({disableAddressCheck: true}) && !isAwaitingProduct) {
            replace(urls.location(CheckoutStages.DELIVERY));
        }

        // Payment form is empty
        else if (!paymentForm && thisRoute.name !== CheckoutStages.PAYMENT) {
            replace(urls.location(CheckoutStages.PAYMENT));
        }
    },
};
